import { FETCHING_PENDING_EMPLOYEE_JOBS, PENDING_EMPLOYEE_JOBS_FETCHED } from '../actions/pendingEmployeeJob'

const INITIAL_STATE = {
  jobs: { list: [], total: 0 },
  loading: true
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCHING_PENDING_EMPLOYEE_JOBS:
      return handleFetchingJobs(state, action)
    case PENDING_EMPLOYEE_JOBS_FETCHED:
      return handleJobsFetched(state, action)
    default:
      return state
  }
}

function handleFetchingJobs (state, action) {
  const { loading } = action
  return { ...state, loading }
}

function handleJobsFetched (state, action) {
  const { jobs, loading } = action
  return { ...state, jobs, loading }
}
